<template>
  <div class="container" id="about">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="page section-group">
            <div class="card p-5">
              <h1 class="page-title mb-2">{{$t('common.about.t1')}}</h1>
              <hr class="divider" />
              <div class="page-content mb-4">
                <div class="about section-group">
                  <blockquote class="blockquote">
                    <p>
                      {{$t('common.about.t2')}}
                    </p>
                  </blockquote>
                  <p>
                    {{$t('common.about.t3')}}
                    <br />{{$t('common.about.t4')}}
                  </p>
                  <div class="row">
                    <div class="col-sm-12 col-lg-4">
                      <div class="about-grid">
                        <div class="our-service">
                          <img
                            src="../../assets/images/footer/about/service-1.png"
                          />
                          <p>
                            {{$t('common.about.t5')}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-4">
                      <div class="about-grid">
                        <div class="our-service">
                          <img
                            src="../../assets/images/footer/about/service-2.png"
                          />
                          <p>
                            {{$t('common.about.t6')}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-4">
                      <div class="about-grid">
                        <div class="our-service">
                          <img
                            src="../../assets/images/footer/about/service-3.png"
                          />
                          <p>
                            {{$t('common.about.t7')}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3>{{$t('common.about.t7-2')}}</h3>
                  <div class="row">
                    <div class="col-sm-12 col-lg-3">
                      <div class="about-grid">
                        <div class="our-mission">
                          <img
                            src="../../assets/images/footer/about/mission-1.png"
                          />
                          <p>
                            {{$t('common.about.t8')}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-3">
                      <div class="about-grid">
                        <div class="our-mission">
                          <img
                            src="../../assets/images/footer/about/mission-2.png"
                          />
                          <p>
                            {{$t('common.about.t9')}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-3">
                      <div class="about-grid">
                        <div class="our-mission">
                          <img
                            src="../../assets/images/footer/about/mission-3.png"
                          />
                          <p>
                            {{$t('common.about.t10')}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-3">
                      <div class="about-grid">
                        <div class="our-mission">
                          <img
                            src="../../assets/images/footer/about/mission-4.png"
                          />
                          <p>
                            {{$t('common.about.t11')}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h3>{{$t('common.about.t12')}}</h3>
                  <div class="row">
                    <ol type="a">
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t13')}}
                      </li>
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t14')}}
                      </li>
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t15')}}
                      </li>
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t16')}}
                      </li>
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t17')}}
                      </li>
                      <li>
                        <img
                          src="../../assets/images/footer/about/arrow.png"
                          class="mx-2"
                        />{{$t('common.about.t18')}}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ./頁面內容 -->
  </div>
</template>
<script>
export default {
  data() {},
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/about.vue